import React, { Component } from 'react';

class mainNav extends Component {

  render() {

    return (
        <nav className="main-nav">
        <a href="#be-a-hero" className="be-a-hero">Be a Hero</a>
        <a href="#small-actions" className="small-actions">Small Actions</a>
        <a href="#why-it-matters" className="why-it-matters">Why it Matters</a>
        <a href="#get-support" className="get-support">Get Support</a>
        </nav>      
    );
  }
}

export default mainNav;



// WEBPACK FOOTER //
// ./src/components/header/nav/mainnav/mainnav.js